<template>
  <div
    v-if="coinsured.length > 0"
    :title="label"
    class="truncate text-xs md:text-sm"
  >
    <FaIcon
      name="users"
      variant="light"
      class="mr-1"
    />
    {{ label }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Coinsured } from '@/api/contracts/types';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { useBaseDataStore } from '@/user/store/baseDataStore';

interface Props {
  coinsured: Coinsured[],
}

const props = defineProps<Props>();

const { isCompany } = useBaseDataStore();

const label = computed(() => {
  const count = props.coinsured.length;
  const firstFullName = `${props.coinsured[0]?.firstName} ${props.coinsured[0]?.lastName}`;
  const persons = count > 1
    ? `Personen: ${firstFullName} + ${count - 1} weitere`
    : `Person: ${firstFullName}`;

  return `${isCompany ? 'Versicherte' : 'Mitversicherte'} ${persons}`;
});
</script>
